import { useCallback } from 'react';
import { matchPath } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import { useGeneralRoutes } from '@namespace/cms';
import {
  getSessionStorageValue,
  SESSION_STORAGE_KEYS
} from '@namespace/helpers';
import { useLocation } from '@namespace/i18n';
import { useHistory, useSearchParams } from '@namespace/router';

export const useGetPromotionGoBack = (
  activePromoType: string,
  opts: { isUseGoBack?: boolean } = {}
) => {
  const prevPathname = getSessionStorageValue(
    SESSION_STORAGE_KEYS.PREV_PATHNAME,
    ''
  );
  const { backTo } = useSearchParams();
  const { push, goBack } = useHistory();
  const { promotions, login } = useGeneralRoutes();
  const { pathname } = useLocation();

  const isPrevLoginPage = !isEmpty(matchPath({ path: login }, prevPathname));

  const promotionsCategory = `${promotions}/${activePromoType}`;

  return useCallback(() => {
    if (backTo) {
      push(backTo);

      return;
    }

    // ideally always need to use goBack.
    // "push" was added as a fix for specific locale change case (see BTB-4352) which seems to be relevant only for ua13 for now
    if (prevPathname && !isPrevLoginPage && prevPathname !== pathname) {
      if (opts?.isUseGoBack) {
        goBack();
      } else {
        push(prevPathname);
      }

      return;
    }

    push(promotionsCategory);
  }, [
    backTo,
    prevPathname,
    isPrevLoginPage,
    pathname,
    push,
    promotionsCategory,
    opts?.isUseGoBack,
    goBack
  ]);
};
